// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Belgium from '../_raw/flag/icon_flag_belgium.png';

export default () => <img src={Belgium} alt="Belgium" />;
